module.exports = new __parcel__URL__("formUnavailableIcon.af176d7e.svg").toString();